import {
  IsNotEmpty,
  IsIn,
  IsOptional,
  IsNumber,
  IsBoolean,
  ValidateNested,
  ValidateIf,
  IsString,
  IsInt,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@eagerdog/constants";

import { IShowElement } from "./show-element.interface";
import { ShowElementExerciseDto } from "./show-element-exercise.dto";

// UKC Conformation: "Total Dog" is always judged by the same judge who does the
// regular/altered breed judging, and "Total Junior" is judged as part of that same
// overall comparison whenever "Total Dog" is offered — neither needs its own dedicated
// judge, so they're exempt from the judge_name requirement below.
const ELEMENT_LEVELS_WITHOUT_DEDICATED_JUDGE = [
  Constants.dog_class_element_level.total_dog,
  Constants.dog_class_element_level.total_junior,
];

export class ShowElementDto implements IShowElement {
  @IsNotEmpty()
  @IsIn(Object.values(Constants.dog_class_element))
  show_element: string;

  @IsOptional()
  @IsIn([null, ...Object.values(Constants.dog_class_element_level)])
  level?: string;

  @IsOptional()
  @IsIn([null, ...Object.values(Constants.dog_class_section)])
  section?: string;

  @ValidateIf((o: ShowElementDto) => !ELEMENT_LEVELS_WITHOUT_DEDICATED_JUDGE.includes(o.level as any))
  @IsNotEmpty()
  judge_name: string;

  @IsOptional()
  judge_number?: string;

  @IsOptional()
  @IsNumber()
  fee?: number;

  @IsOptional()
  @IsNumber()
  early_bird_fee?: number;

  @IsOptional()
  @IsNumber()
  max_entries?: number;

  @IsOptional()
  order_of_exercises?: string;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => ShowElementExerciseDto)
  exercises?: ShowElementExerciseDto[];

  @IsOptional()
  @IsBoolean()
  waitlist_enabled?: boolean;

  @IsOptional()
  @IsNumber()
  waitlist_size?: number;

  @IsOptional()
  ring?: string;

  @IsOptional()
  use_club_name?: string;

  @IsOptional()
  @IsBoolean()
  use_judge_name?: boolean;

  // AKC Scentwork specific fields
  @IsOptional()
  @IsNumber()
  num_hides?: number;

  @IsOptional()
  @IsString()
  time_limit?: string;

  // UKC Dock Jumping specific fields
  @IsOptional()
  @IsInt()
  @IsIn([1, 2, 3, 4, 5, 6])
  splash_count?: number;
}
